import React from "react";
import { useTranslation } from "react-i18next";
import { CurrencySelect } from "@/components/ui/currency-select";

export function CurrencyRow({
  name,
  value,
  disabled,
  onChange,
}: {
  name?: string;
  value?: string;
  disabled?: boolean;
  onChange?: (currency: string) => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="border-base-border bg-secondary-badge min-h-24 rounded-lg border p-4">
      <CurrencySelect
        className="w-full"
        name={name}
        value={value}
        disabled={disabled}
        label={t("billing.paymentCurrency")}
        onChange={onChange ? (currency) => onChange(currency) : () => {}}
      />
    </div>
  );
}
